/* unplugin-vue-components disabled */import script from "./addEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./addEditModal.vue?vue&type=script&lang=ts&setup=true"

import "./addEditModal.vue?vue&type=style&index=0&id=51c3613b&lang=css"

const __exports__ = script;

export default __exports__